const events_fr = require('./events.json')
export default events_fr